import { ApiCore } from '../utilities/ApiCore'
import dbConnection from '../utilities/dbConnection';
import { handleError, handleResponse } from '../utilities/Response';

const url = 'auth';

const apiAuth = new ApiCore({
    post: true,
    getAll: true,
    url,
    extra: true,
})

apiAuth.login = (login_data) => {
    return dbConnection.post(`/${ url }/login`, login_data)
        .then( handleResponse )
        .catch( handleError )
}
apiAuth.verificarToken = apiAuth.getAll;

export default apiAuth;